module.exports = __webpack_public_path__ + "img/logo.844e71de.png";